import {Toast,Indicator } from 'mint-ui';

/**
 * 获取url页面参数
 * @param name 参数名
 * @returns {null}
 */
function getQueryString(name) {
  var reg = new RegExp("(^|&|\\?)"+ name +"=([^&]*)(&|$)");
  var r = window.location.href.substr(1).match(reg);
  if(r!=null)return  unescape(r[2]); return null;
}

/**
 * 第一版的图片压缩功能
 * @param dataurl      图片路径 不支持跨域
 * @param max_size     图片大小
 * @param bool         是否强制改变大小 true(小于max_size强制变成 max_size大小)
 * @returns {Promise}
 */
function resizeImage (dataurl,max_size = 1200,bool=false) {
  Indicator.open();
  let doResolve
  const promise = new Promise((resolve, reject) => { doResolve = resolve })


  const img = document.getElementById('hidden-img')
  img.src = dataurl

  setTimeout(() => {
    const canvas = document.createElement('canvas')
    let initSize = img.src.length;
    let width = img.width
    let height = img.height
    // console.log('original', width, height, dataurl.length)

    let ratio = max_size / (width > height ? height : width)
    if (ratio < 1) {
      height *= ratio
      width *= ratio
    } else {

      if(bool){
        height = max_size
        width = max_size
      }else{
        console.log('原始输出：' + initSize);
        Indicator.close()
        return doResolve(dataurl)
      }


    }

    canvas.width = width
    canvas.height = height

    const ctx = canvas.getContext('2d')
    //铺底色
    ctx.fillStyle = "#fff"
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    ctx.drawImage(img, 0, 0, width, height)
    const resizedDataurl = canvas.toDataURL('image/jpeg', 0.7)
    console.log('压缩前：' + initSize);
    console.log('压缩后：' + resizedDataurl.length);
    console.log('压缩率：' + ~~(100 * (initSize - resizedDataurl.length) / initSize) + "%");
    Indicator.close()
    doResolve(resizedDataurl)
  }, 100)

  return promise
}

function compress(dataurl) {
  let doResolve
  const promise = new Promise((resolve, reject) => { doResolve = resolve })

  const img = document.getElementById('hidden-img')
  img.src = dataurl

  setTimeout(() => {
    //用于压缩图片的canvas
    const canvas = document.createElement("canvas");
    const ctx = canvas.getContext('2d');
    //瓦片canvas
    const tCanvas = document.createElement("canvas")
    const tctx = tCanvas.getContext("2d");

    let initSize = img.src.length;
    let width = img.width;
    let height = img.height;

    //如果图片大于四百万像素，计算压缩比并将大小压至400万以下
    var ratio;
    if ((ratio = width * height / 4000000)>1) {
      ratio = Math.sqrt(ratio);
      width /= ratio;
      height /= ratio;
    }else {
      ratio = 1;
    }

    canvas.width = width;
    canvas.height = height;

    //铺底色
    ctx.fillStyle = "#fff";
    ctx.fillRect(0, 0, canvas.width, canvas.height);

    //如果图片像素大于100万则使用瓦片绘制
    var count;
    if ((count = width * height / 1000000) > 1) {
      //计算要分成多少块瓦片
      count = ~~(Math.sqrt(count)+1);
      //计算每块瓦片的宽和高
      var nw = ~~(width / count);
      var nh = ~~(height / count);
      tCanvas.width = nw;
      tCanvas.height = nh;
      for (var i = 0; i < count; i++) {
        for (var j = 0; j < count; j++) {
          tctx.drawImage(img, i * nw * ratio, j * nh * ratio, nw * ratio, nh * ratio, 0, 0, nw, nh);
          ctx.drawImage(tCanvas, i * nw, j * nh, nw, nh);
        }
      }
    } else {
      ctx.drawImage(img, 0, 0, width, height);
    }

    //进行最小压缩
    var ndata = canvas.toDataURL('image/jpeg', 0.5);

    console.log('压缩前：' + initSize);
    console.log('压缩后：' + ndata.length);
    console.log('压缩率：' + ~~(100 * (initSize - ndata.length) / initSize) + "%");

    tCanvas.width = tCanvas.height = canvas.width = canvas.height = 0;
    doResolve(ndata)
  },0)

  return promise;
}
/**
 * 显示错误信息
 * @param msg      错误信息
 * @param type     显示位置
 * @param duration 显示的毫秒数
 */
function showMsg(msg,type = 'bottom',duration=3000) {
  Toast({
    message: msg,
    position: type,
    duration: duration,
  });
}

/**
 * 验证设备号
 * @param substring
 */
function verify_device_id(substring){
  var ret = substring.search(/[^A-Za-z0-9_-]/g)
  //console.log(substring,ret)
  if(ret==-1){
    return false;//正常
  }
  return true;//不合法
}

/**
 * 克隆对象
 * @param obj
 * @returns {*}
 */
const deepClone=(obj)=>({
  __proto__: Object.getPrototypeOf(obj),
  ...obj
})
/**
 * 克隆ImageData(内存泄露bug)
 * @param obj
 * @returns {*}
 */
function copyImageData(imagedata){
  return new ImageData(new Uint8ClampedArray(imagedata.data),imagedata.width,imagedata.height);
}

/**
 * 取正数
 * @param $num
 * @returns {*}
 */
function positive($num) {
   if($num<0){
     return - $num;
   }
   return $num;
}

/**
 * 数组根据某个key取对象
 * @param arr
 * @param key
 * @param value
 * @returns {*}
 */
function get_arr_obj_by_key(arr,key,value){
   for(let item of arr){
      if(item[key] == value){
          return item;
      }
   }
   return null;
}


function getColor(color='#5f4120') {
  return `<style>
    .mint-header-kf{
      background-color: ${color}!important;
    }
    .primary-kf{
      background-color: ${color}!important;
    }
    .is-plain-kf{
      color:${color}!important;
      border-color: ${color}!important;
    }
    .mt-range-progress{
      background-color: ${color}!important;
    }
    .upload-box .icon-hexagon{
       color:${color}!important;
    }
    .mint-switch-core{
        border-color: #ccc!important;
        background-color: ${color}!important;
    }
    .weui-dialog__btn_primary{
       color: ${color}!important;
    }
</style>`
}
var browser={
  versions:function(){
    var u = navigator.userAgent,
      app = navigator.appVersion;
    return {
      trident: u.indexOf('Trident') > -1, //IE内核
      presto: u.indexOf('Presto') > -1, //opera内核
      webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
      gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') == -1,//火狐内核
      mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
      ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
      android: u.indexOf('Android') > -1 || u.indexOf('Adr') > -1, //android终端
      iPhone: u.indexOf('iPhone') > -1 , //是否为iPhone或者QQHD浏览器
      iPad: u.indexOf('iPad') > -1, //是否iPad
      webApp: u.indexOf('Safari') == -1, //是否web应该程序，没有头部与底部
      weixin: u.indexOf('MicroMessenger') > -1, //是否微信 （2015-01-22新增）
      qq: u.match(/\sQQ/i) == " qq" //是否QQ
    };
  }(),
  language:(navigator.browserLanguage || navigator.language).toLowerCase()
}



export {resizeImage,showMsg,verify_device_id,compress,deepClone,copyImageData,positive,getColor,getQueryString,browser,get_arr_obj_by_key}



// WEBPACK FOOTER //
// ./src/tools/other.js